import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

export const useWordGroupData = (moduleId, groupId) => {
  const [groupData, setGroupData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const loadGroup = useCallback(async () => {
    if (!moduleId || !groupId) {
      setGroupData(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Get user session
      const { data: { session } } = await supabase.auth.getSession();
      const userId = session?.user?.id;
      
      if (!userId) {
        setError('User not authenticated');
        return;
      }

      // Fetch word group by ID directly (moduleId is already the module UUID)
      const { data, error: fetchError } = await supabase
        .from('word_groups')
        .select('*')
        .eq('module_id', moduleId)
        .eq('id', groupId)
        .single();

      if (fetchError) {
        setError('Error fetching word group');
        return;
      }

      setGroupData(data);
    } catch (err) {
      setError('Error fetching word group');
    } finally {
      setLoading(false);
    }
  }, [moduleId, groupId]);

  useEffect(() => {
    loadGroup();
  }, [loadGroup]);

  return {
    groupData,
    loading,
    error,
    refetch: loadGroup,
  };
};
